export function convertToRelativeTime(timestamp: string): string {
	const now = new Date();
	const date = new Date(timestamp);

	if (isNaN(date.getTime())) {
		throw new Error("Invalid timestamp format");
	}

	const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);
	const weeks = Math.floor(days / 7);
	const months = Math.floor(days / 30);
	const years = Math.floor(days / 365);

	if (years > 0) {
		return `${years}y ago`;
	} else if (months > 0) {
		return `${months}mo ago`;
	} else if (weeks > 0) {
		return `${weeks}w ago`;
	} else if (days > 0) {
		return `${days}d ago`;
	} else if (hours > 0) {
		return `${hours}h ago`;
	} else if (minutes > 0) {
		return `${minutes}m ago`;
	} else {
		return `${seconds}s ago`;
	}
}
